// extracted by mini-css-extract-plugin
export default {"tasksWrapper":"DrawDetailPage_tasksWrapper__NGySh"};